import './Tenders.css';

const Tenders = () => {
    return (
        <div className="tenders-page">
            <section className="page-hero">
                <div className="container">
                    <h1 className="display-medium animated">Tenders</h1>
                    <p className="body-large hero-subtitle animated delay-200">Current opportunities with Zengamina Power Limited</p>
                </div>
            </section>

            <section className="tenders-content-section">
                <div className="container">
                    <div className="no-tenders-message">
                        <div className="icon-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                                <line x1="9" y1="15" x2="15" y2="15"></line>
                            </svg>
                        </div>
                        <h2 className="heading-2">Currently no tenders available</h2>
                        <p className="body-large text-muted">Please check back later for new opportunities.</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Tenders;
